document.addEventListener("shopify:section:load", initVideos);
document.addEventListener("DOMContentLoaded", initVideos);

function initVideos() {
  const deferredMedia = document.querySelectorAll("deferred-media");

  deferredMedia.forEach((media) => {
    const template = media.querySelector("template");

    if (template) {
      const content = template.content.cloneNode(true);
      media.appendChild(content);
      template.remove();
    }

    const video = media.querySelector("video");
    if (video) {
      video.muted = true;
      video.loop = true;
      video.autoplay = true;
      video.play().catch(() => {});
    }

    const poster = media.querySelector(".deferred-media__poster");
    if (poster) poster.style.display = "none";
  });
}


document.addEventListener("DOMContentLoaded", function () {

  const input = document.querySelector('[id^="NewsletterPhone--"]');

  if (!input) return;

  window.intlTelInput(input, {
    initialCountry: "au",
    separateDialCode: true,
    preferredCountries: ["au", "in", "us", "gb"]
  });

});





document.querySelectorAll('.accordion__inner').forEach((accordion) => {
    accordion.addEventListener('toggle', function () {
        const icon = this.querySelector('.accordion-icon');

        if (this.open) {
            icon.textContent = '−';
        } else {
            icon.textContent = '+';
        }
    });
});


window.addEventListener('load', function () {
  document.querySelectorAll('.main-product__media-badge').forEach(function (el) {
    if (el.textContent.trim().toLowerCase() === 'made to order') {
      el.classList.add('made-to-order');
    }
  });
});